import type { IErrorType } from '../../constants/types';
import type { IContentCategoryCatalog } from '../../utils/contentCategoriesApi';

export const types = {
    FETCH: 'contentCategories/FETCH',
    FETCH_SUCCESS: 'contentCategories/FETCH_SUCCESS',
    FETCH_FAIL: 'contentCategories/FETCH_FAIL',
    CLEAR: 'contentCategories/CLEAR',
} as const;

export interface IContentCategoriesState {
    catalog: IContentCategoryCatalog | null;
    fetching: boolean;
    error: IErrorType | null;
}

export type IFetchContentCategoriesPayload = { force?: boolean } | undefined;
